import React from 'react';
import PrismicImage from '@components/shared/images/atoms/Image/PrismicImage';
import breakpoints from '@constants/breakpoints';
import { IPrismicImage } from '@lib/prismic/types';
import classNames from 'classnames';
import styles from './halfImageHalfText.module.scss';

interface IHalfImageHalfText {
  className?: string;
  children?: React.ReactNode;
  description?: string;
  constrast?: boolean;
  backgroundColor: string;
  image: IPrismicImage;
  textWrapperClass?: string;
}

const mobileBreakpoint = breakpoints.tablet;

export default function HalfImageHalfText({
  className = '',
  backgroundColor,
  image,
  textWrapperClass = '',
  children
}: IHalfImageHalfText) {
  return (
    <section className={`${styles.Root} ${className}`} style={{ backgroundColor }}>
      <div className={styles.Image}>
        <PrismicImage
          image={image}
          breakpoints={{
            mobile: mobileBreakpoint,
          }}
        />
      </div>
      <div className={classNames(styles.CardWrapper, textWrapperClass)}>
        {children}
      </div>
    </section>
  );
}
